import React from "react";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import PersonalInfoFields from "./benne-request/PersonalInfoFields";
import AddressFields from "./benne-request/AddressFields";
import RentalDetailsFields from "./benne-request/RentalDetailsFields";
import { useFormSubmission } from "./benne-request/useFormSubmission";
import { Send } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
const BenneRequestForm = () => {
  const {
    form,
    onSubmit,
    isSubmitting
  } = useFormSubmission();
  return <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <PersonalInfoFields />
        <AddressFields />
        <RentalDetailsFields />

        <Alert className="bg-blue-50 border-blue-200">
          <AlertDescription>
            En cliquant sur "Envoyer la demande", nous recevrons directement votre demande par email et vous confirmerons la réception.
          </AlertDescription>
        </Alert>

        <div className="space-y-2">
          <Button type="submit" className="w-full md:w-auto bg-fabre-green hover:bg-fabre-darkgreen flex items-center" disabled={isSubmitting}>
            {isSubmitting ? "Envoi en cours..." : "Envoyer la demande"}
            <Send className="ml-2 h-4 w-4" />
          </Button>
          <p className="text-sm text-gray-600">Vous pouvez également nous contacter directement à contactgfe@groupefabre.com ou par téléphone au 05.65.67.82.05.</p>
        </div>
      </form>
    </Form>;
};
export default BenneRequestForm;